import { render, staticRenderFns } from "./DownPaymentRelatedExtOrderTable.vue?vue&type=template&id=1ab01e8d&scoped=true&"
import script from "./DownPaymentRelatedExtOrderTable.vue?vue&type=script&lang=ts&"
export * from "./DownPaymentRelatedExtOrderTable.vue?vue&type=script&lang=ts&"
import style0 from "./DownPaymentRelatedExtOrderTable.vue?vue&type=style&index=0&id=1ab01e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab01e8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
